import React from 'react'
import { IsAuthorizeUser } from '../../lib/authenticationLibrary';
import Unauthorize from '../../pages/unauthorize/Unauthorize';

const AuthorizationWrap = ({ authorizationRole, children }) => {
    return (
        <>
            {
                (IsAuthorizeUser(authorizationRole)) ? children : <Unauthorize />
            }
        </>
    )
}

export default AuthorizationWrap;